import { render, staticRenderFns } from "./FadeLink.vue?vue&type=template&id=ce980c52&"
import script from "./FadeLink.vue?vue&type=script&lang=js&"
export * from "./FadeLink.vue?vue&type=script&lang=js&"
import style0 from "./FadeLink.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports